import { useAppSelector } from './use.redux';

export function useUser() {
  const { user, state, favoriteDoctors } = useAppSelector((reducers) => reducers.userReducer);
  return {
    user,
    userState: state,
    favoriteDoctors,
    authenticated: !!user,
    userId: user?._id as string,
    userType: user?.type,
  };
}
